import { html } from "lit-html";
import { ifDefined } from "lit/directives/if-defined.js";
import { unsafeHTML } from "lit/directives/unsafe-html.js";
import { formatHtml } from "@trumpf/ux.common-storybook";
import {
    decoratorDefault,
    decoratorMenu,
    getSubmenuSlot,
} from "./menu.templates";

interface TemplateArgs {
    label?: string;
    name?: string;
    current?: boolean;
    expanded?: boolean;
    onUxMenuItemExpand?: (event: CustomEvent) => void;
    onUxMenuItemClick?: (event: CustomEvent) => void;
    _slot?: string;
}

const Template = ({
    label,
    name,
    current,
    expanded,
    onUxMenuItemExpand,
    onUxMenuItemClick,
    _slot = "",
}: TemplateArgs) =>
    html`<ux-iws-sf-menu-item
        label=${ifDefined(label)}
        name=${ifDefined(name)}
        ?current=${ifDefined(current)}
        ?expanded=${ifDefined(expanded)}
        @uxMenuItemExpand=${ifDefined(onUxMenuItemExpand)}
        @uxMenuItemClick=${ifDefined(onUxMenuItemClick)}
        >${unsafeHTML(_slot)}</ux-iws-sf-menu-item
    >`;

const TemplateMultiple = ({
    onUxMenuItemExpand,
    onUxMenuItemClick,
}: TemplateArgs) => {
    const args = {
        onUxMenuItemExpand,
        onUxMenuItemClick,
    };
    const sampleItems = [
        { label: "Start Page", name: "start_page" },
        { label: "User Data", name: "user_data" },
        { label: "Account Data", name: "account_data" },
        { label: "Change Password", name: "change_password" },
        { label: "Delete Account", name: "delete_account" },
    ];

    return html`
        ${sampleItems.map(({ label, name }) =>
            Template({
                ...args,
                label,
                name,
                current: name === sampleItems[2].name,
            })
        )}
    `;
};

const TemplateNested = ({
    onUxMenuItemExpand,
    onUxMenuItemClick,
}: TemplateArgs) => {
    const args = {
        onUxMenuItemExpand,
        onUxMenuItemClick,
    };
    const labels = ["Menu Item 1", "Menu Item 2"];
    return html`
        ${labels.map((label) =>
            Template({
                ...args,
                label,
                expanded: label === labels[0],
                _slot: getSubmenuSlot(label, 3),
            })
        )}
    `;
};

export default {
    title: "Salesforce/Components/Menu/Menu Item",
    component: "ux-iws-sf-menu-item",
    parameters: {
        docs: {
            source: {
                transform: formatHtml,
            },
        },
    },
    argTypes: {
        _slot: {
            table: { disable: true },
        },
    },
    args: {
        label: "Menu Item 1",
        expanded: false,
        onUxMenuItemExpand: (event) => {
            console.log(event.type, event.target);
        },
        onUxMenuItemClick: (event) => {
            console.log(event.type, event.target);
        },
    },
};

export const Default = {
    render: Template.bind({}),
    decorators: [decoratorDefault],
};

export const Multiple = {
    render: TemplateMultiple.bind({}),
    decorators: [decoratorMenu],
};

export const Nested = {
    render: TemplateNested.bind({}),
    decorators: [decoratorMenu],
};
